import { StackData } from "@/types/Stack";
import { StackTableComponent } from "@/components/tables/StackTableComponent"
import { useData } from "@/hooks/useData";
import { Stack, columns } from "./StackColumn";



export default function DriveOffTable({
  stackData,
}: {
  stackData: StackData[] | undefined;
}) {
  const {
    selectedLocation
  } = useData();
  function setData(driveOffsData: StackData[]): Stack[] {
    if (!selectedLocation || selectedLocation.id === undefined) {
      return [];
    }

    // Fetch data from your API here.
    const result = driveOffsData
      .filter(data => selectedLocation.id === data.LocationID && data.StackSize > 0
      ).map(data => ({
        timeStamp: data.TimeStamp,
        location: selectedLocation,
        stackSize: data.StackSize,
        duration: data.TimeDiff
      }));
    return result as Stack[]
  }
  if (stackData) {
    const data = setData(stackData)
    return (

      <StackTableComponent columns={columns} data={data} />
    )
  }
  return <></>
}
